<template>
	<div class="pt-2">
		<CommonFlame :title="title">
			<v-select
				class="mt-4"
				v-model="period"
				:items="periods"
				dense
				outlined
				suffix="期"
				:style="{ width: $vuetify.breakpoint.xs ? '100%' : '300px' }"
				@change="searchConstructions($event)"
			/>
			<div class="table-container mt-4">
				<v-data-table
					locale="ja-JP"
					:items="constructions"
					:headers="headers"
					:mobile-breakpoint="240"
					hide-default-footer
					disable-filtering
					disable-pagination
					disable-sort
					no-data-text="データがありません。"
				>
					<template v-slot:item="{ item }">
						<tr @click="openMenu(item)">
							<!-- TODO -->
						</tr>
					</template>
				</v-data-table>
			</div>
			<v-menu v-model="showMenu" :position-x="position.x" :position-y="position.y">
				<v-list>
					<v-list-item
						v-for="(item, i) in menuItems"
						@click="item.routeName ? item.action(item.routeName) : item.action"
						:key="i"
						>{{ item.name }}</v-list-item
					>
				</v-list>
			</v-menu>

			<PaginationModule :pagination="pagination" @get-page="getPage($event)"></PaginationModule>
		</CommonFlame>
		<ShippingDateNewDialog :dialog.sync="shippingDateDialog" :construction="selectedItem" />
		<!-- TODO:014自由添付 order_individual_infoに紐づくか不明・調整すること-->
		<OrderIndividualInfoAttachedFileIndexDialog
			:dialog.sync="attachedFilesDialog"
			:id="idForAttachedFiles"
		/>
	</div>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import common from "../../helper/common"
import CommonFlame from "../shared/CommonFlame.vue"
import PaginationModule from "../../modules/PaginationModule.vue"
import CostSearchSection from "./components/ConstructionCostSearchSection.vue"
import ShippingDateNewDialog from "./components/ConstructionShippingDateNewDialog.vue"
import OrderIndividualInfoAttachedFileIndexDialog from "../attached_file/components/OrderIndividualInfoAttachedFileIndexDialog.vue"

export default {
	components: {
		CommonFlame,
		PaginationModule,
		ShippingDateNewDialog,
		OrderIndividualInfoAttachedFileIndexDialog,
		CostSearchSection,
	},
	data() {
		return {
			title: "工事管理台帳",
			constructions: [], // モデル名不明のためconstructions
			periods: [],
			period: null,
			authority_flag: false,
			headers: headers(),
			menuItems: [
				{ action: this.renderPage, routeName: "construction_process_index", name: "工事工程表" },
				{
					action: this.renderPage,
					routeName: "construction_construction_worker_index",
					name: "外注管理",
				},
				{ action: this.openShippingDateNewDialog, name: "着工・出荷入力" },
				{
					action: this.renderPage,
					routeName: "construction_construction_schedule_index",
					name: "日報入力",
				},
				{ action: this.openAttachedFilesDialog, name: "自由添付" },
				{ action: this.renderPage, routeName: "constructions_rubber_index", name: "材料計画" },
			],
			pagination: {
				count: null,
				current: 1,
				limit_value: null,
				next: null,
				pages: null,
				previous: null,
			},
			position: {
				x: 0,
				y: 0,
			},
			selectedItem: null,
			idForAttachedFiles: null,
			showMenu: false,
			shippingDateDialog: false,
			attachedFilesDialog: false,
			q: {
				sorts: "created_at desc",
				// TODO
			},
			dialog: false,
			common,
		}
	},

	mounted() {
		const page = this.$route.query.page ? this.$route.query.page : 1
		this.setQuery()
		// this.fetchConstructions(this.q, page, true)
	},
	methods: {
		fetchConstructions(q, page, first_visit = false) {
			const headers = authenticate.setHeader()
			const params = { page, q, first_visit }
			axios
				.get("/erp/v1/constructions/constructions", {
					params,
					headers,
				})
				.then((res) => {
					this.constructions = res.data.constructions
					this.pagination = res.data.pagination
					// 初回のアクセスのみデータを取得する
					if (first_visit) {
						this.periods = res.data.periods
						this.authority_flag = res.data.authority_flag
					}
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		openMenu(item) {
			this.selectedItem = item
			this.showMenu = true
			this.position.x = event.clientX
			this.position.y = event.clientY
		},
		openShippingDateNewDialog() {
			this.shippingDateDialog = true
		},
		openAttachedFilesDialog() {
			this.idForAttachedFiles = this.selectedItem.id // 紐づくOrderIndividualInfoのdd
			this.attachedFilesDialog = true
		},
		renderPage(name) {
			this.$router.push({ name: name, params: { id: this.selectedItem?.id } })
		},
		getPage(page) {
			this.fetchConstructions(this.q, page)
			this.$router.push({
				name: this.$route.name,
				query: { page: page, ...this.q },
			})
			window.scrollTo({
				top: 0,
				behavior: "smooth",
			})
		},
		searchConstructions(period) {
			// TODO
			this.q = {}
			this.fetchConstructions(this.q, 1)
			this.$router.push({
				name: this.$route.name,
				query: { ...this.q, page: 1 },
			})
		},
		setQuery() {
			const query = this.$route.query
			let q = this.q
			Object.keys(this.$route.query).forEach((query_key) => {
				if (query[query_key] && query_key != "page") {
					q[query_key] = this.formatQuery(query[query_key])
				}
			})
			this.q = q
		},
		formatQuery(query) {
			if (query instanceof Array) {
				return query.map((v) => (isFinite(v) ? Number(v) : v))
			} else if (isFinite(query)) {
				return Number(query)
			} else {
				return query
			}
		},
		openInNewTab(url) {
			window.open(url, "_blank")
		},
	},
}

function headers() {
	// TODO: value入力
	return [
		{
			text: "納期",
			value: "",
			width: "120px",
		},
		{
			text: "台帳番号",
			value: "",
			width: "120px",
		},
		{
			text: "製番",
			value: "",
			width: "120px",
		},
		{
			text: "管理No.",
			value: "",
			width: "120px",
		},
		{
			text: "施工期日",
			value: "",
			width: "120px",
		},
		{
			text: "受注先",
			value: "",
			width: "200px",
		},
		{
			text: "プラントメーカー",
			value: "",
			width: "200px",
		},
		{
			text: "施工場所",
			value: "",
			width: "200px",
		},
		{
			text: "工事名",
			value: "",
			width: "200px",
		},
		{
			text: "品名",
			value: "",
			width: "120px",
		},
		{
			text: "工数",
			value: "",
			width: "120px",
		},
		{
			text: "出荷日",
			value: "",
			width: "120px",
		},
		{
			text: "金額",
			value: "",
			width: "120px",
		},
		{
			text: "生産月",
			value: "",
			width: "120px",
		},
	]
}
</script>
